import {
  SCORE_BAND_NEEDS_REVIEW_MIN,
  SCORE_BAND_STRONG_MIN,
  scoreToBand,
} from "@nexus/contracts";

import type { PreflightScoreBand } from "../types/preflight.types";

export { SCORE_BAND_STRONG_MIN, SCORE_BAND_NEEDS_REVIEW_MIN, scoreToBand };

/** Semantic design tone per band (KTD11): success/warning/error. */
export type BandTone = "success" | "warning" | "error";

const BAND_TONES: Record<PreflightScoreBand, BandTone> = {
  STRONG: "success",
  NEEDS_REVIEW: "warning",
  AT_RISK: "error",
};

/** Semantic tone token for a band — never use color alone, always pair with text/icon. */
export function bandTone(band: PreflightScoreBand): BandTone {
  return BAND_TONES[band];
}
